import styled from 'styled-components';

export const ToastContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const ToastButtonsContainer = styled.div`
    display: flex;
    column-gap: 1rem;
`;
